export enum Environment {
  Local = 'local',
  Staging = 'staging',
  Production = 'production',
}

const getCurrentEnv = (): Environment => {
  const hostname = window.location.hostname

  if (hostname.includes(Environment.Staging)) {
    return Environment.Staging
  }

  if (hostname.includes(Environment.Local)) {
    return Environment.Local
  }

  return Environment.Production
}

export const currentEnv = getCurrentEnv()
